import getFullAddressString from 'src/util/address';

/**
 * Filters properties for admin list by multiple criteria.
 * Searches across property fields (title, externalIdentifier, address).
 * Uses case-insensitive substring matching.
 * @param {Array} propertyEdges - Array of property edge objects from GraphQL connection
 * @param {string} searchTerm - The search term to filter by
 * @returns {Array} Filtered array of property edges
 * @example
 * const filtered = getFilteredPropertiesAdmin(properties.edges, 'melbourne');
 * // Returns edges where any searchable field contains 'melbourne'
 */
export default function getFilteredPropertiesAdmin(propertyEdges, searchTerm) {
  // Guard against null/undefined propertyEdges
  if (!propertyEdges || !Array.isArray(propertyEdges)) {
    return [];
  }

  // Return full list if no search term
  if (!searchTerm) return propertyEdges;

  const searchTermLower = searchTerm.toLowerCase();

  return propertyEdges.filter((edge) => {
    // Guard against null/undefined edge or edge.node
    if (!edge || !edge.node) {
      return false;
    }

    const property = edge.node;

    // Property title match
    const titleMatch = property.title?.toLowerCase().includes(searchTermLower) ?? false;

    // External identifier match
    const externalIdMatch = property.externalIdentifier?.toLowerCase()
      .includes(searchTermLower) ?? false;

    // Address match (searches all address fields: line1, line2, city, state, postcode)
    const addressString = getFullAddressString(property.address) ?? '';
    const addressMatch = addressString.toLowerCase().includes(searchTermLower);

    // Return true if ANY field matches (OR logic)
    return titleMatch || externalIdMatch || addressMatch;
  });
}
